module.exports = __webpack_public_path__ + "img/discover.cc165403.svg";